import type { ParseMethod } from '../types'

import humps from 'humps'

export const parse =
  <T>(parseMethod: ParseMethod<T>) =>
  (response: Response): null | Promise<T | null> => {
    if (response.status === 204 || response.status === 205) {
      return null
    }

    return parseMethod(response)
  }

export const camelizeJSON = (json: Record<string, unknown>): object =>
  humps.camelizeKeys(json)
